import axiosRetry from 'axios-retry';
import config from './config.api';
import { axiosWithHeaders } from '@innovyze/lib_get_service';

const sharedTemplatesApi = axiosWithHeaders({
	service: 'sharedTemplates',
	config,
	injectTenantId: false,
	axiosCreateOpts: {
		timeout: 10000,
	},
});

axiosRetry(sharedTemplatesApi, {
	retries: 3,
	retryDelay: retryCount => {
		return retryCount * 1000;
	},
});

export default sharedTemplatesApi;
